import React from 'react'

import SEO from 'components/elements/SEO'
import TemplateContact from 'components/templates/TemplateContact'
import {TPageComponent} from 'src/types'

interface IContactProps {}

const Contact: TPageComponent<IContactProps> = () => {
	return (
		<>
			<SEO
				keywords="contact paystub.org"
				title="Contact Us - Paystub.org"
				description="Contact us at Paystub.org using this form if you have any questions about our online paystub generator or want to learn more about features and pricing."
			/>
			<TemplateContact />
		</>
	)
}

Contact.displayName = 'Contact'

export default Contact
